export const robloxDataTypes = {
    roblox_transaction_history: {
        data_type: 'roblox_transaction_history',
        data_type_description: 'Roblox Transactions',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/roblox/logo.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: false,
        generic: {
        },
        file_source: 'localStorage',
        instructions_type: 'component'
    },
}
